import { ArrowLeft } from "assets/svg";

interface PageBackProps {
  onBack: () => void;
  classname?: string
}

export function PageBack({ onBack, classname = '' }: PageBackProps) {
  return (
    <button
      className="rounded-full border border-1 border-solid border-white"
      onClick={onBack}
    >
      <img src={ArrowLeft} alt="arrow-back" className={classname} />
    </button>
  );
}
